import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-money-transfer',
    templateUrl: './money-transfer.component.html',
    styleUrls: ['./money-transfer.component.scss']
})
export class MoneyTransferComponent implements OnInit {

    constructor(
        public router: Router
    ) { }

    ngOnInit() {}

}